import { RepositoryConfigModel } from '../models/repository-config.model';
import { DbContext } from './db-context';

export class RepositoriesConfig {
    static repositories: RepositoryConfigModel[] = [
        new RepositoryConfigModel({
            tableName: DbContext.FailedRequests,
            canSyncUp: false
        }),
        new RepositoryConfigModel({
            tableName: DbContext.TablesStates,
            canSyncUp: false
        }),
        new RepositoryConfigModel({
            tableName: DbContext.UnsyncedChanges,
            index: 'recordId',
            canSyncUp: false
        }),
        new RepositoryConfigModel({
            tableName: DbContext.Bookings,
            index: 'customerID'
        }),
        new RepositoryConfigModel({
            tableName: DbContext.Customers
        }),
        new RepositoryConfigModel({
            tableName: DbContext.Allocations
        }),
        new RepositoryConfigModel({
            tableName: DbContext.Providers,
            canSyncUp: false
        }),
        new RepositoryConfigModel({
            tableName: DbContext.Todos
        }),
        new RepositoryConfigModel({
            tableName: DbContext.Templates,
            index: 'org',
            canSyncUp: false
        })
    ];
}
